import api from "./api";

const BASE = "/app-marketplace";
const BASE_CAT = "/app-marketplace-categories";

// ── Categorias ───────────────────────────────────────────────
export const listCategories = () => api.get(BASE_CAT);
export const createCategory = (data) => api.post(BASE_CAT, data);
export const updateCategory = (id, data) => api.put(`${BASE_CAT}/${id}`, data);
export const deleteCategory = (id) => api.delete(`${BASE_CAT}/${id}`);

export const listMarketplace = () => api.get(BASE);

export const listMarketplaceAdmin = () => api.get(`${BASE}/admin`);

export const getMarketplaceItem = (id) => api.get(`${BASE}/${id}`);

export const createMarketplaceItem = (formData) =>
  api.post(BASE, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const updateMarketplaceItem = (id, formData) =>
  api.put(`${BASE}/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteMarketplaceItem = (id) => api.delete(`${BASE}/${id}`);

export const uploadGalleryImage = (id, formData) =>
  api.post(`${BASE}/${id}/gallery`, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const removeGalleryImage = (id, imagePath) =>
  api.delete(`${BASE}/${id}/gallery`, { data: { imagePath } });

export const uploadVideoFile = (id, formData) =>
  api.post(`${BASE}/${id}/video-file`, formData, { headers: { "Content-Type": "multipart/form-data" } });
